import { Language } from '@/i18n/Language';

/**
 * Extracts the language from an AMR (Authentication Method Reference) string.
 * The AMR string is expected to be in the format "language:otherInfo".
 *
 * Examples of AMR strings:
 * - "no:bankid:regular"
 * - "se:bankid:mobile"
 * - "dk:eid:mitid"
 * - "azure:ad:oidc"
 * - "pwd:mfa"
 *
 * @param amr - The AMR string from which to extract the language.
 * @returns The extracted language, or English as default.
 */
export const findLanguageFromAmr = (amr: string | undefined): Language => {
  const match = amr?.match(/^(\w+):/);
  /*
   * For example, if the AMR string is "no:bankid:regular", the match returns an array:
   * [
   *   "no:",      // Full match (index 0)
   *   "no"        // First capturing group (index 1)
   * ]
   * The regex stops here and doesn't care about "bankid:regular"
   */
  const prefix = match?.[1];

  switch (prefix) {
    case 'no':
    case 'azure': // Internal user with SSO. We default to Norwegian for internal users.
      return Language.Norwegian;

    case 'se':
      return Language.Swedish;

    case 'dk':
      // Connect does not support the Danish language.
      return Language.English;

    case 'pwd':
      // Password-based authentication is most likely used by international users.
      return Language.English;

    default:
      console.warn(`Unsupported language [${prefix}] in AMR [${amr}]`);
      return Language.English;
  }
};
